module.exports = __webpack_public_path__ + "static/img/red-envelope-modal.8f5dfd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/red-envelope-modal.png
// module id = nwrB
// module chunks = 216